import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';

export function proposalRequestDatesValidator(
  ProposalRequestFormGroup: AbstractControl
): ValidationErrors | null {
  const startDate = ProposalRequestFormGroup.get('startDate')?.value;
  const dueDate = ProposalRequestFormGroup.get('dueDate')?.value;
  const reminderDate = ProposalRequestFormGroup.get('reminderDate')?.value;

  let { errors } = ProposalRequestFormGroup;

  if (
    startDate &&
    DateTime.fromJSDate(startDate).diff(
      DateTime.fromJSDate(new Date()),
      'millisecond'
    ).milliseconds <= 0
  ) {
    errors = Object.assign(errors || {}, { startDateLessThanToday: true });
  } else {
    if (errors) {
      delete errors['startDateLessThanToday'];
    }
  }

  if (
    startDate &&
    dueDate &&
    DateTime.fromJSDate(startDate).diff(
      DateTime.fromJSDate(dueDate),
      'millisecond'
    ).milliseconds <= 0
  ) {
    errors = Object.assign(errors || {}, { dueDateGreaterThanStartDate: true });
  } else {
    if (errors) {
      delete errors['dueDateGreaterThanStartDate'];
    }
  }

  if (
    startDate &&
    dueDate &&
    reminderDate &&
    (DateTime.fromJSDate(reminderDate).diff(
      DateTime.fromJSDate(dueDate),
      'millisecond'
    ).milliseconds >= 0 ||
      DateTime.fromJSDate(reminderDate).diff(
        DateTime.fromJSDate(startDate),
        'millisecond'
      ).milliseconds >= 0)
  ) {
    errors = Object.assign(errors || {}, { reminderDateInvalid: true });
  } else {
    if (errors) {
      delete errors['reminderDateInvalid'];
    }
  }

  if (isEmpty(errors)) {
    errors = null;
  }

  ProposalRequestFormGroup.setErrors(errors);
  return errors;
}
